import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AddJobAllJobsProfile from "../../StylesWrappers/General/AddJobAllJobsProfile";
import InputSection from "../../components/AllJobs/InputSection";
import TitleText from "../../components/General/Helmet";
import { AppDispatch, RootState } from "../../store";
import ShowAllJobs from "../../components/AllJobs/ShowAllJobs";
import {
  clearSearchFields,
  collectSearchFields,
  declinedCount,
  decreasePage,
  increasePage,
  interviewCount,
  jobsPerPage,
  pendingCount,
  searchStatusJobs,
} from "../../features/stat/statSlice";
import { capitalize } from "../../utils/capitalize";
import { Pagination } from "../../components/General/helpers";
import { addQueryParams } from "../../utils/queryParams";
import JobCardSkeleton from "../../components/Skeletons/JobCardSkeleton";
import AllJobsWrapper from "../../StylesWrappers/AllJobs/showAllJobs";

const StatusBasedJobs = () => {
  const {
    statusBasedJobs,
    statusSearch,
    currentStatusPage,
    pageStatusSize,
    totalPages,
  } = useSelector((store: RootState) => store.statStore);
  const { isLoading } = useSelector((store: RootState) => store.allJobsStore);
  const { statLoading } = useSelector((store: RootState) => store.statStore);

  const { search, statusValue, typeValue } = statusSearch;

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const pathname = useLocation().pathname;

  const splitUrl = pathname.split("/");
  const getStatus = splitUrl[splitUrl.length - 1];

  // Handle input change
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    dispatch(collectSearchFields({ name, value }));
  };

  // Handle select change
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let name = e.target.name;
    let value = e.target.value;
    dispatch(collectSearchFields({ name, value }));
  };

  // Clear input field
  const handleClear = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(clearSearchFields());
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentStatusPage, pageStatusSize);
  }, [pathname, currentStatusPage, pageStatusSize]);

  // Fetch status based jobs when the status based jobs loads
  useEffect(() => {
    // Get status pathname
    const checkStatusArr = pathname.split("/");
    const checkStatus = checkStatusArr[checkStatusArr.length - 1];

    dispatch(clearSearchFields()); // Clear serach before making another request

    if (checkStatus === "pending") {
      dispatch(pendingCount({ currentStatusPage, pageStatusSize }));
      // console.log(statusBasedJobs);
      return;
    }
    if (checkStatus === "interview") {
      dispatch(interviewCount({ currentStatusPage, pageStatusSize }));
      return;
    }
    if (checkStatus === "decline") {
      dispatch(declinedCount({ currentStatusPage, pageStatusSize }));
    }
  }, [dispatch, pathname, currentStatusPage, pageStatusSize]);

  // INTIATE SEARCH WHEN SEARCH, STATUSvALUE OR TYPEVALUE CHANGES
  useEffect(() => {
    dispatch(searchStatusJobs({ search, statusValue, typeValue }));
  }, [search, statusValue, typeValue, dispatch]);

  // Loading state for status based jobs
  if (isLoading || statLoading) {
    return <JobCardSkeleton cards={4} />;
  }

  // Display no job for zero status based jobs
  if (statusBasedJobs.length === 0) {
    return (
      <AllJobsWrapper>
        <p className="no__job">NO JOBS TO DISPLAY</p>
      </AllJobsWrapper>
    );
  }

  return (
    <>
      <AddJobAllJobsProfile>
        <TitleText title={`Jobtrackier - All ${capitalize(getStatus)} Jobs`} />
        <InputSection
          search={search}
          status={statusValue}
          type={typeValue}
          searchName="search"
          statusName="statusValue"
          typeName="typeValue"
          handleChange={handleChange}
          handleSelect={handleSelect}
          handleClear={handleClear}
        />
      </AddJobAllJobsProfile>
      <ShowAllJobs
        allJobsProps={statusBasedJobs}
        countCheck={statusBasedJobs.length}
      />
      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        currentPage={currentStatusPage}
        pageSize={pageStatusSize}
        totalPages={totalPages}
      />
    </>
  );
};

export default StatusBasedJobs;
